export const checklistStepFragment = `
  id
  name
  required
  title
  complete
  type
  completeDate
  docCacheId
  status
  docInfo {
    docId
    docName
    docTitle
    level
    order
    criteria {
      systems
      expireDays
      locations
      ageGroups
      insurances
    }
    fileName
    active
  }
`;

export const demographicTypesFragment = `
  maritalStatus {
    key
    value
  }
  race {
    key
    value
  }
  ethnicity {
    key
    value
  }
  religion {
    key
    value
  }
  primaryLanguage {
    key
    value
  }
`;

export const patientInfoFragment = `
  id
  cernerPersonId
  firstName
  lastName
  middleName
  dateOfBirth
  gender
  addresses {
    address1
    address2
    city
    state
    zip
    type
  }
  phones {
    areaCode
    phoneNumber
    type
    countryCode
  }
  emails {
    address
    type
  }
  demographics {
    maritalStatus
    races
    ethnicity
    religion
    primaryLanguage
  }`;

export const activityFragment = `
  isMspqFormRequired
  insuranceVerification
  costEstimation
  service
  patientDemographics
  priorBalance
  authorization
  FCCContact
  isPlanOutOfNetwork
`;

export const locationFragment = `
  facilityCode
  name
  longitude
  latitude
  address {
    street1
    city
    postalCode
    state
  }
  campusMap
  phone {
    areaCode
    localNumber
  }
`;

export const encounterInfoFragment = `
  id
  admitDate
  centralTeam
  cancelled
  patientTypeDescription
`;

export const visitDetailFragment = `
  id
  arType
  facilityCode
  facilityName
  finNumber
  startDate
  type
  serviceLocation
  serviceDescription
  insurance {
    insuranceOrder
    payerName
    payerPlanName
    groupID
    plancode
    memberID
    verificationStatus
  }
  payment {
    totalChargeInCents
    priorBalanceInCents
    patientResponsibilityInCents
    insurancePaymentInCents
  }
  activity {
    ${activityFragment}
  }
  location {
    ${locationFragment}
  }
  `;
